define('views/modules/calendar/nutrition/food/favorite/list/food-favorite-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/nutrition/food/list/food-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VFoodItem
) {

    var VFoodFavoriteItem = VFoodItem.extend({

        getData: function() {
            var defaultServing = this.options.defaultServing,
                diplayTitle = this.getServing().getDisplayTitle();

            return _.extend({
                _isEditable: this.model.isEditable(),
                defaultServing: defaultServing ? diplayTitle : false,
                isFavorite: this.isFavorite()
            }, this.model.get('food'));
        },

        getFoodId: function() {
            return this.model.getFoodId();
        },

        getFood: function() {
            return this.model.getFood();
        },

        getServing: function() {
            return this.getFood().getDefaultServing();
        },

        isFavorite: function() {
            return this.model;
        },

        ////////////
        // events //
        ////////////
        onAddFavoriteClick: function() {
            var favorite = this.isFavorite();
            this.remove();
            favorite.destroy();
        },
        onFoodEditClick: function() {
            if (this.model.get('type') === "recipe") {
                this.model.trigger("recipe:edit", this.model);
            } else {
                VFoodFavoriteItem.__super__.onFoodEditClick.apply(this, arguments);
            }

        },

    });

    return VFoodFavoriteItem;

});

